import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { AlertBox } from '@/components/AlertBox';

import { useTranslation } from 'react-i18next';

import { Button, SvgIcon } from '@/components';
import { userSelectors } from '@/redux/selectors';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { userActions } from '@/redux/actions';
import { LANDING_LINKS } from '@/config/landing-links';

import { ModalInfo } from '../ModalInfo';
import styles from './AgreementModal.module.sass';

export interface AgreementModalProps {
  isOpen: boolean;
}

export const AgreementModal = ({ isOpen }: AgreementModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { loading, error } = useAppSelector(userSelectors.getUserSlice);

  const handleOnAgree = useCallback(() => {
    dispatch(userActions.confirmTerms({}));
  }, [dispatch]);

  return (
    <ModalInfo
      isOpen={isOpen}
      isShowCloseButton={false}
      className={styles.modal}
    >
      <div className={styles.title}>
        {t('translation.agreement_modal.title')}
      </div>

      <div className={styles.description}>
        {t('translation.agreement_modal.description')}{' '}
        <SvgIcon name="arrow-right" />{' '}
        <Link
          to={LANDING_LINKS.TERMS_OF_SERVICE_PAGE_URL}
          target="_blank"
          className={styles.link}
        >
          {t('translation.agreement_modal.agreements')}
        </Link>
      </div>

      {!!error && (
        <AlertBox type="danger" className={styles.error}>
          {{
            description: error,
          }}
        </AlertBox>
      )}

      <Button
        size="xl"
        disabled={loading}
        isLoading={loading}
        className={styles.button}
        onClick={handleOnAgree}
        fullwidth
      >
        {t('translation.agreement_modal.accept')}
      </Button>
    </ModalInfo>
  );
};
